import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface WhiteBorderWrapperProps {
  children: ReactNode;
  className?: string;
}

export const WhiteBorderWrapper = ({
  children,
  className,
}: WhiteBorderWrapperProps) => (
  <div
    className={classNames(
      "hidden w-1/2 flex-col items-center justify-center bg-white p-6 lg:flex lg:w-[55%]",
      className,
    )}
  >
    {children}
  </div>
);
